/** The placement check — a short graded ladder that says where to start.
 *
 * Built from the practice questions that already exist, so it costs no AI
 * credits and needs no new content.
 */
import { request } from "./http";

export interface PlacementQuestion {
  id: string;
  level: string;
  item_type: string;
  title: string;
  /** Sanitised — the answer key never leaves the server. */
  payload: Record<string, unknown>;
}

export interface PlacementSet {
  previous_level: string | null;
  questions: PlacementQuestion[];
}

export interface PlacementResult {
  level: string;
  cleared: string[];
  reason: string;
  answered: number;
  per_level: Record<string, { correct: number; total: number }>;
}

export function placementQuestions(): Promise<PlacementSet> {
  return request("/placement/");
}

export function submitPlacement(
  answers: Record<string, Record<string, unknown>>,
): Promise<PlacementResult> {
  return request("/placement/", { method: "POST", body: { answers } });
}
